import { cn } from "@/lib/utils";

const partners = [
  { name: "SKF Bearings", logo: "/images/brands/skf_clean.png" },
  { name: "FAG Bearings", logo: "/images/brands/fag_clean.png" },
  { name: "NBC Bearings", logo: "/images/brands/nbc_clean.png" },
  { name: "NSK Japan", logo: "/images/brands/nsk_clean.png" },
  { name: "Timken", logo: "/images/brands/Timken.png" },
  { name: "NTN", logo: "/images/brands/ntn.png" },
  { name: "Koyo", logo: "/images/brands/koyo.webp" },
  { name: "INA", logo: "/images/brands/INA.png" },
  { name: "Nachi", logo: "/images/brands/nachi.png" },
  { name: "THK", logo: "/images/brands/thk.png" },
  { name: "Hiwin", logo: "/images/brands/hiwin.webp" },
  { name: "Kluber Grease", logo: "/images/brands/kluber_clean.png" },
  { name: "RHP England", logo: "/images/brands/rhp.png" }
];

export function PartnersSection() {
  return (
    <section id="partners" className="py-16 md:py-24 bg-background overflow-hidden relative">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808008_1px,transparent_1px),linear-gradient(to_bottom,#80808008_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none"></div>

      <div className="container relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-black mb-4 tracking-tight">Authorized Brands</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Providing authentic, high-precision components from the world's most trusted manufacturers.
          </p>
        </div>
        
        {/* Infinite Scrolling Marquee Wrapper */}
        <div className="relative w-full overflow-hidden py-4">
          {/* Fade Gradients for visual aesthetics */}
          <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-background via-background/70 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-background via-background/70 to-transparent z-10 pointer-events-none"></div>

          {/* Marquee Inner Flex */}
          <div className="flex w-max animate-marquee hover:[animation-play-state:paused] will-change-transform">
            {/* Set 1 */}
            <div className="flex items-center gap-6 sm:gap-8 px-3 sm:px-4">
              {partners.map((partner, index) => (
                <div key={`set1-${index}`} className="w-[160px] sm:w-[200px] h-24 sm:h-28 flex-shrink-0 group">
                  <div className="relative w-full h-full rounded-xl border border-border/80 bg-white dark:bg-white p-4 flex items-center justify-center overflow-hidden transition-all duration-300 hover:shadow-lg hover:border-primary/40 hover:-translate-y-1">
                    <img
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      className="max-h-[75%] max-w-[85%] object-contain transition-all duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                    {/* Minimalist Name Tag showing on hover */}
                    <div className="absolute bottom-1.5 left-1/2 -translate-x-1/2 opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 bg-background/95 backdrop-blur-sm px-2.5 py-0.5 rounded-full border shadow-sm pointer-events-none">
                      <span className="text-[10px] font-semibold whitespace-nowrap text-foreground">{partner.name}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Set 2 (Seamless loop duplicate) */}
            <div className="flex items-center gap-6 sm:gap-8 px-3 sm:px-4" aria-hidden="true">
              {partners.map((partner, index) => (
                <div key={`set2-${index}`} className="w-[160px] sm:w-[200px] h-24 sm:h-28 flex-shrink-0 group">
                  <div className="relative w-full h-full rounded-xl border border-border/80 bg-white dark:bg-white p-4 flex items-center justify-center overflow-hidden transition-all duration-300 hover:shadow-lg hover:border-primary/40 hover:-translate-y-1">
                    <img
                      src={partner.logo}
                      alt={`${partner.name} logo`}
                      className="max-h-[75%] max-w-[85%] object-contain transition-all duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                    {/* Minimalist Name Tag showing on hover */}
                    <div className="absolute bottom-1.5 left-1/2 -translate-x-1/2 opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300 bg-background/95 backdrop-blur-sm px-2.5 py-0.5 rounded-full border shadow-sm pointer-events-none">
                      <span className="text-[10px] font-semibold whitespace-nowrap text-foreground">{partner.name}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
